import api from 'Application/api/api';

const getTags = signal =>
	api.get('/tags/get-pageable', {
		signal,
	});

export default getTags;
